module.exports = {"350825100":"莲峰镇","350825101":"北团镇","350825102":"姑田镇","350825103":"朋口镇","350825104":"莒溪镇","350825105":"新泉镇","350825106":"庙前镇","350825107":"文亨镇","350825108":"四堡镇","350825109":"林坊镇","350825200":"揭乐乡","350825201":"塘前乡","350825202":"隔川乡","350825204":"罗坊乡","350825208":"曲溪乡","350825209":"赖源乡","350825210":"宣和乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350825.json
// module id = 1235
// module chunks = 0